import React from "react";
import WalletBtn from "../../../assets/images/wallet_btn.png";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import {walletConvert, walletHistory, walletReqPayHistory} from "../../../Utility/Url";
import PicoLoader from "../Common/PicoLoader";
import {dialogBackground, dialogBorderColor, dialogContentColor, dialogContentTextColor} from "../../../Utility/Theme";
import {withRouter} from "react-router-dom";
class WalletButton extends React.Component{
    constructor() {
        super();
        this.state = {
            style: {},
        }
    }
    componentDidMount() {
    }

    loadData= async(type)=>{
        switch (type) {
            case 'walletReqPayHistory':
                axios.get(walletReqPayHistory)
                    .then(res => {
                        const {data}=res
                        const newData=
                            data.list.map(data=>
                                `<div class="MuiGrid-root wallet-button-content-message MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center" 
                                    style="margin: 10px 0px;background-color: ${ data.status=='0'?'orange':
                                    data.status=='1'?'green':
                                        data.status=='-1'?'red':'red'} ">
                                    <div class="MuiGrid-root wallet-button-content-message-inner MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-12 MuiGrid-grid-sm-12">
                                        <div class="MuiGrid-root wallet-button-content-message-inner-title MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5"
                                            style="background-color: ${ data.status=='0'?'orange':
                                    data.status=='1'?'green':
                                        data.status=='-1'?'red':'red'} "
                                               >
                                            <p>${data.date}</p>
                                        </div>
                                        <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7"></div><div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7">
                                    </div>
                                    <div class="MuiGrid-root wallet-button-content-message-inner-description MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5">
                                        <p>${data.desc}</p>
                                    </div>
                                        <div class="MuiGrid-root wallet-button-content-message-inner-price-text MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5">
                                            <div class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end">
                                                <p>مبلغ</p>
                                            </div>
                                            <div class="MuiGrid-root wallet-button-content-message-inner-price MuiGrid-container MuiGrid-item MuiGrid-justify-xs-center">
                                                <p>${data.reqValue}</p>
                                            </div>
                                        </div>
                                        <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7"></div>
                                    </div>
                                </div>`
                            )
                        let temp = document.querySelector('.im-dialog-inner .wallet-button-content')
                        temp.innerHTML=newData
                    }).catch(error=>{
                        console.log(error.toString())
                    }
                )
                break
            case 'walletHistory':
                axios.get(walletHistory)
                    .then(res => {
                        const {data}=res
                        const newData=
                            data.list.map(data=>
                                `<div class="MuiGrid-root wallet-button-content-message MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center" 
                                    style="margin: 10px 0px;background-color: ${data.value<'0'?'red':'green'}">
                                    <div class="MuiGrid-root wallet-button-content-message-inner MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-12 MuiGrid-grid-sm-12">
                                        <div class="MuiGrid-root wallet-button-content-message-inner-title MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5"
                                            style="background-color: 
                                                ${data.value<'0'?'red':'green'}">
                                            <p>${data.timestamp}</p>
                                        </div>
                                        <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7"></div><div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7">
                                    </div>
                                    <div class="MuiGrid-root wallet-button-content-message-inner-description MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5">
                                        <p>${data.description}</p>
                                    </div>
                                        <div class="MuiGrid-root wallet-button-content-message-inner-price-text MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5">
                                            <div class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end">
                                                <p>مبلغ</p>
                                            </div>
                                            <div class="MuiGrid-root wallet-button-content-message-inner-price MuiGrid-container MuiGrid-item MuiGrid-justify-xs-center">
                                                <p>${data.value}</p>
                                            </div>
                                        </div>
                                        <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7"></div>
                                    </div>
                                </div>`
                            )
                        let temp = document.querySelector('.im-dialog-inner .wallet-button-content')
                        temp.innerHTML=newData
                    }).catch(error=>{
                        console.log(error.toString())
                    }
                )
                break
            case 'goldConverter':
                const {
                    info:{canChangeGolden,toGoldenString}
                }
                    =this.props
                if (canChangeGolden)
                    axios.get(`${walletConvert}/golden`)
                        .then(res => {
                            const {data}=res
                        }).catch(error=>{
                            console.log(error.toString())
                        }
                    )
                else {
                    const obg ={
                        dialog:{
                            success:false,
                            ok:null,
                            message:toGoldenString,
                            style: {
                                background: dialogBackground,
                                borderColor: dialogBorderColor,
                                contentColor: dialogContentColor,
                                contentTextColor: dialogContentTextColor,
                                type: "danger",
                            },
                            cancel:{
                                action: "#cancel",
                                text: 'باشه'
                            }
                        }
                    }
                    this.props.dialog(obg)
                }
                break
            case 'silverConverter':
                const {
                    info:{canChangeSilver,toSilverString}
                }
                    =this.props
                if (canChangeSilver)
                    axios.get(`${walletConvert}/silver`)
                        .then(res => {
                            const {data}=res
                        }).catch(error=>{
                            console.log(error.toString())
                        }
                    )
                else {
                    const obg ={
                        dialog:{
                            success:false,
                            ok:null,
                            message:toSilverString,
                            style: {
                                background: dialogBackground,
                                borderColor: dialogBorderColor,
                                contentColor: dialogContentColor,
                                contentTextColor: dialogContentTextColor,
                                type: "danger",
                            },
                            cancel:{
                                action: "#cancel",
                                text: 'باشه'
                            }
                        }

                    }
                    this.props.dialog(obg)
                }
                break

        }
    }
    handleClick = (e,data,width) => {
        const closeDialog=()=> {
            this.props.toggleIndexNav('close')
            dialogInner.classList.remove('im-active')
            dialogInner.style.transform = `translate3d(${first.x - last.x}px, ${first.y - last.y}px, 0px) scaleX(1)`
            dialogInner.style.border = 'none'
            setTimeout(() => {
                dialog.remove()
            }, 350)
        }

        const dialog = document.createElement('div')
        dialog.classList.add('im-dialog')
        const html = e.target.closest('.wallet-button')
        const first = html.getBoundingClientRect()
        const dialogBackdrop = document.createElement('div')
        dialogBackdrop.classList.add('im-dialog-backdrop')
        dialogBackdrop.onclick = closeDialog
        dialog.appendChild(dialogBackdrop)
        const dialogInner = document.createElement('div')
        dialogInner.classList.add('im-dialog-inner')
        dialogInner.style.width=`${first.width}px`
        dialogInner.style.height=`${first.height}px`
        dialogInner.appendChild(html.querySelector('.wallet-button-content').cloneNode(true))
        const button = document.createElement('button')
        button.classList.add('im-dialog-close')
        button.innerHTML = `بازگشت`
        button.onclick = closeDialog
        dialog.appendChild(dialogInner)
        dialog.appendChild(button)
        document.body.appendChild(dialog)
        const last = dialogInner.getBoundingClientRect()
        dialogInner.style.transform = `translate3d(${first.x - last.x}px, ${first.y - last.y}px, 0px) scaleX(1)`
        requestAnimationFrame(() => {
            dialogInner.style.transform = ''
            dialogInner.style.transition = 'transform 0.3s ease-out 0s, width .3s ease-out, height .3s ease-out'
            dialogInner.classList.add('im-active')
        })

        // e.target.parentElement.parentElement.style.width=`px`
        // e.target.parentElement.parentElement.classList.add('items-section-active')

    }
    render() {
        const {
            data:{icon,textColor,text,direction,id,hasDialog},
            info:{canChangeGolden,canChangeSilver,toGolden,toGoldenString,toSilver,toSilverString,value}
        }=this.props

        return(
            <Grid container alignItems={"flex-start"}  id='iman' justify={"center"} className='wallet-button'
                  onClick={(e,data)=>{
                      if (hasDialog) {
                          this.props.history.push(`/settings/${id}`)
                          return
                          var element = document.getElementById('iman');
                          var positionInfo = element.getBoundingClientRect();
                          var height = positionInfo.height;
                          var width = positionInfo.width;
                          this.props.toggleIndexNav('open')
                          this.handleClick(e,data,width)
                      }
                      this.loadData(id)
                  }}>
                <Grid alignItems='center' container sm={12} item
                      justify='space-around' direction={direction}
                      style={{
                          backgroundImage:"url(" + WalletBtn + ")",
                          backgroundSize: '100% 100%',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: '50% 50%',
                          height:'100%',
                          minHeight:'120px',
                          padding:'10px'}}
                >
                    <Grid item>
                        <img className='wallet-button-icon' src={icon} alt=""/>
                    </Grid>
                    <Grid item>
                        <p style={{color:textColor}} className='wallet-button-text'>{text}</p>
                    </Grid>
                </Grid>
                <Grid  className='wallet-button-content' container justify={"center"} alignItems={ "center"}
                       style={{
                           borderRadius:'20px',
                           backgroundColor:'#183549',
                           padding:'20px',
                           position:'relative'
                       }}
                >
                    <Grid sm={2} xs={2} container alignItems={"center"} justify={"center"}
                          style={{
                              position:'relative',
                              // top:'50%',
                              // left:'50%',
                              // transform:'translate(-50%,-50%)',
                              // backgroundColor:'red'
                          }}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                    {/*<Grid container alignItems={"center"} justify={"center"} className='wallet-button-content-message' style={{margin:'10px 0'}}>*/}
                    {/*<Grid className='wallet-button-content-message-inner' xs={12} sm={12} container alignItems={"center"} justify={"center"}>*/}
                    {/*    <Grid xs={5} sm={5} className='wallet-button-content-message-inner-title' container alignItems={"center"} justify={"center"}>*/}
                    {/*        <p >1399/06/09</p>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid xs={7} sm={7} container alignItems={"center"} justify={"flex-start"}>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid xs={7} sm={7} container alignItems={"center"} justify={"flex-start"}>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid xs={5} className='wallet-button-content-message-inner-description' sm={5} container alignItems={"center"} justify={"center"}>*/}
                    {/*        <p>در صف انتظار </p>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid className='wallet-button-content-message-inner-price-text' xs={5} sm={5} container alignItems={"center"} justify={"center"}>*/}
                    {/*        <Grid  item container justify={"flex-end"}>*/}
                    {/*            <p >مبلغ</p>*/}
                    {/*        </Grid>*/}
                    {/*        <Grid className='wallet-button-content-message-inner-price' item container justify={"center"}>*/}
                    {/*            <p >300000</p>*/}
                    {/*        </Grid>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid xs={7} sm={7} container alignItems={"center"} justify={"flex-start"}>*/}
                    {/*    </Grid>*/}
                    {/* </Grid>*/}
                    {/*</Grid>*/}
                </Grid>
            </Grid>

        )
    }
}
export default (withRouter(WalletButton))